import ApplicationController from './application_controller';

// Manages visibility of the SMS consent field based on phone number type selection.
// Works in two contexts:
//   1. Patient profile form — standard <select> with mobileIdValue
//   2. Intake document smart component — Impulse auto-complete with typeTextInput target
export default class extends ApplicationController {
  static targets = ['typeSelect', 'typeTextInput', 'smsField'];
  static values = { mobileId: String, intakeDocument: Boolean };

  connect() {
    this.updateVisibility();
  }

  // Called by the standard <select> change event on the patient profile form.
  typeSelectChanged() {
    this.updateVisibility();
  }

  // Called by auto-complete:selected on the smart component type auto-complete.
  onTypeSelected(event) {
    const typeName = event.detail?.relatedTarget?.dataset?.autocompleteValue || '';
    this.setSmsVisible(typeName.toLowerCase() === 'mobile');
  }

  // Called by auto-complete:reset when the type field is cleared.
  onTypeReset() {
    this.setSmsVisible(false);
  }

  // Private

  updateVisibility() {
    if (this.hasTypeSelectTarget) {
      const typeId = this.typeSelectTarget.value;
      this.setSmsVisible(typeId === this.mobileIdValue);
    } else if (this.hasTypeTextInputTarget) {
      const typeName = this.typeTextInputTarget.value.trim().toLowerCase();
      this.setSmsVisible(typeName === 'mobile');
    }
  }

  setSmsVisible(show) {
    if (this.hasSmsFieldTarget) {
      this.smsFieldTarget.classList.toggle('d-none', !show);
    }
  }
}
